module.exports = __webpack_public_path__ + "img/flanelle_chine.f808c72d.jpeg";